import { breadcrumbStyles } from "@dana/Overrides/Widgets/Basic/Breadcrumbs";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { css } from "styled-components";

breadcrumbStyles.pageBreadcrumbs = mergeToNew(breadcrumbStyles.pageBreadcrumbs, {
    breadcrumbs: {
        css: css`
            padding: 16px 0;

            a {
                text-decoration: none;

                &:hover,
                &:focus,
                &:focus-visible {
                    text-decoration: none;
                    outline-offset: 0px;
                    border-radius: 0px;
                }

                span {
                    text-decoration: none;
                }
            }
        `,
    },
});
